import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    type: 'browser',
    list: [],
    collection: {},
    isLoading: false
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
